import React from "react";
import PropTypes from "prop-types";
import { useMyWorkByProjectNavigation } from "~/components/Hooks/useMyWorkByProjectNavigation";
import { TaskSheet } from "./TaskSheet";

export const MyWorkByProjectNavigation = React.forwardRef(({ taskId, userId, ...props }, ref) => {
  const [prev, next] = useMyWorkByProjectNavigation(taskId, userId);
  return (
    <TaskSheet
      ref={ref}
      taskId={taskId}
      prev={prev}
      next={next}
      {...props}
    />
  );
});

MyWorkByProjectNavigation.propTypes = {
  taskId: PropTypes.number,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
};

MyWorkByProjectNavigation.displayName = "MyWorkByProjectNavigation";
